import tutcode from "../images/POS.png";
import enjeck from "../images/Pwebsite.png";
import ll from "../images/libre-logos.svg";
import gfolio from "../images/gfolio.png";
import jpg2svg from "../images/jpg2svg.png";
import gg from "../images/geo-guess.png";
import blobby from "../images/blobby.png";
import cav from "../images/CryptographyVisualizer.png"
import placeholder from "../images/bg1.png";
export const ProjectsContent = [
  
  {
    link: `${window.location.origin}`,
    img: gfolio,
    name: "Portfolio (this website)",
    excerpt: `A personal website simulating the Google Search platform. Developed using React`,
    tools: "Nodejs "
  },
  {
    link: "https://darshan01.netlify.app/",
    img: enjeck,
    name: "Personal Website",
    excerpt: `My 1st personal website, designed and developed from scratch. It
    features a lot of hover effects, custom styling and a blog.`,
    tools:``
  },
  {
    link: "https://updating Soon",
    img: tutcode,
    name: "POS demo",
    excerpt: `A modern POS website designed for local businesses in Canada, offering seamless order management, inventory tracking,`,
   tools:` and secure payments. Scalable and user-friendly, it’s built to simplify and empower your operations!`
  },
  
];
